import React from 'react'
import { ReactComponent as InboxIcon } from '@assets/images/Icons/Inbox.svg'
import { ReactComponent as DraftsIcon } from '@assets/images/Icons/Drafts.svg'
import { ReactComponent as SentIcon } from '@assets/images/Icons/Sent.svg'
import { ReactComponent as HistoryIcon } from '@assets/images/Icons/History.svg'
import { ReactComponent as ArchiveIcon } from '@assets/images/Icons/Archive.svg'
import { ReactComponent as DeleteIcon } from '@assets/images/Icons/Delete1.svg'
import { ReactComponent as BlockedIcon } from '@assets/images/Icons/Blocked.svg'
import { ReactComponent as FolderIcon } from '@assets/images/Icons/Folder.svg'
import { ReactComponent as TagIcon } from '@assets/images/Icons/Tag.svg'
import { ReactComponent as StarIcon } from '@assets/images/Icons/Star2.svg'
import { ReactComponent as MailIcon } from '@assets/images/Icons/Mail_fill.svg'
import { ReactComponent as AttentionIcon } from '@assets/images/Icons/Attention.svg'
import { ReactComponent as EditIcon } from '@assets/images/Icons/Edit.svg'
import { ReactComponent as CloseIcon } from '@assets/images/Icons/Close.svg'
import { ReactComponent as CheckmarkIcon } from '@assets/images/Icons/Checkmark.svg'
import { ReactComponent as AddIcon } from '@assets/images/Icons/Add_2.svg'
import { ReactComponent as ChevronIcon } from '@assets/images/Icons/Arrow_down_chevron.svg'
import { ReactComponent as DotIcon } from '@assets/images/Icons/Dot.svg'

type SvgIconComponent = React.FC<React.SVGProps<SVGSVGElement>>

const MailboxSvg: React.FC<{ Icon: SvgIconComponent; className?: string }> = ({
  Icon,
  className = '',
}) => (
  <Icon
    className={`ds-mailbox-nav__svg${className ? ` ${className}` : ''}`}
    aria-hidden="true"
  />
)

/** Design-system Icons used by MailboxNav (from `assets/images/Icons`). */
export const MailboxNavIcons = {
  inbox: () => <MailboxSvg Icon={InboxIcon} />,
  drafts: () => <MailboxSvg Icon={DraftsIcon} />,
  sent: () => <MailboxSvg Icon={SentIcon} />,
  history: () => <MailboxSvg Icon={HistoryIcon} />,
  archive: () => <MailboxSvg Icon={ArchiveIcon} />,
  trash: () => <MailboxSvg Icon={DeleteIcon} />,
  blocked: () => <MailboxSvg Icon={BlockedIcon} />,
  folder: () => <MailboxSvg Icon={FolderIcon} />,
  tag: () => <MailboxSvg Icon={TagIcon} />,
  starred: () => <MailboxSvg Icon={StarIcon} />,
  mail: () => <MailboxSvg Icon={MailIcon} />,
  spam: () => <MailboxSvg Icon={AttentionIcon} />,
  edit: () => <MailboxSvg Icon={EditIcon} />,
  delete: () => <MailboxSvg Icon={DeleteIcon} />,
  close: () => <MailboxSvg Icon={CloseIcon} />,
  save: () => <MailboxSvg Icon={CheckmarkIcon} />,
  add: () => <MailboxSvg Icon={AddIcon} />,
  chevron: () => (
    <MailboxSvg Icon={ChevronIcon} className="ds-mailbox-nav__chevron-svg" />
  ),
  swatch: () => <MailboxSvg Icon={DotIcon} />,
} as const
